<template lang="pug">
  div
    router-view
    //- 以下、タグ内共通モーダル等置けます
</template>

<script>
export default {
  name: 'MergePersons',
  beforeRouteLeave (to, from, next) {
    // sessionStorageを初期化する
    this.resetSession()
    // 一覧検索条件を初期化する
    this.$store.commit('initListConds')

    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/maintenance/duplicated-persons/Index.vue